import nmaps from "./nmaps.js";

var stacker = function(){
  var dmap = nmaps.d;
  var smap = nmaps.s;
  var idmap = nmaps.id;
  var ismap = nmaps.is;
  var str_pairs = [];
  var joiner_str = "";
  var make_pair_parts = function(str){
    joiner_str = "\n";
    var str_parts = str.split(joiner_str);
    if (str_parts && str_parts.length < 2) {
      joiner_str = " ";
      str_parts = str.split(joiner_str);
    }
    return str_parts;
  }
  var make_pairs = function(str){
    str_pairs = [];
    var str_parts = make_pair_parts(str);
    for (var h = 0; h < str_parts.length; (h = h + 2)) {
      str_pairs.push([
        str_parts[h],
        str_parts[h+1] || ""
      ]);
    }
  }
  var shuffle_pair = function(pair){
    if (dmap[pair[0][0]] && !dmap[pair[0][0].codePointAt()]) {
      pair[1] = " " + pair[1];
    }
    var max_length = Math.max(pair[0].length, pair[1].length);
    var pair_str = "";
    for (var i = 0; i < max_length; i++) {
      var b = pair[1][i] || "";
      var t = pair[0][i] || "";
      if (t === " ") {
        t = "";
      }
      var tCode = t.codePointAt();
      if (b && dmap[tCode]) {
        t = String.fromCodePoint.apply(null, dmap[tCode]);
      } else if (smap[tCode]) {
        if (b === " ") {
          b = "";
        }
        t = String.fromCodePoint.apply(null, smap[tCode]);
      }
      pair_str += b + t;
    }
    return pair_str.trim();
  }
  var make = function(str){
    make_pairs(str);
    var shuffled_pairs = [];
    for (var i = 0; i < str_pairs.length; i++) {
      shuffled_pairs.push(shuffle_pair(str_pairs[i]));
    }
    return shuffled_pairs.join(joiner_str);
  }
  var get_stack_type = function(str){
    var str_array = Array.from(str);
    var spaces = 0, same = 0, diff = 0;
    var i;
    for (i = 0; i < str_array.length; i++) {
      var strCode = str_array[i].codePointAt();
      if (idmap[strCode]) {
        if (str[i-1] === " ") {
          spaces++;
        } else if (String.fromCodePoint.apply(null, dmap[str_array[i-1].codePointAt()]) === str_array[i]) {
          same++;
        } else {
    	    diff++;
        }
      }
    }
    if (spaces && !same && !diff) {
      return 'spaces';
    } else if (diff) {
      return 'diff';
    }
  }
  var unmake = function(strs){
    var cleaned_strs = [];
    var str_array = strs.split("\n");
    var fromFunc = (a, i) => {
      if (a === undefined && parts.t[i - 1] === undefined) {
        return " ";
      }
      return a;
    };
    for (var i = 0; i < str_array.length; i++) {
      var str = str_array[i];
      var parts = {"t":[],"b":[]};
      str = str.replace(" ", "  ");
      for (var j = 0; j < str.length; j++) {
        var strCode = str[j].codePointAt();
        var revert = idmap[strCode] || ismap[strCode];
        if (revert) {
          parts.t[j] = String.fromCharCode(revert);
          if (parts.t[j-1]) {
            parts.b[j] = " ";
          }
        } else {
          parts.b[j] = str[j];
        }
      }
      parts.t = Array.from(parts.t, fromFunc);
      cleaned_strs.push([parts.t.join("").trim(), parts.b.join("").trim()].join(" ").replace(/ +/g, " "));
    }
    return cleaned_strs.join("\n");
  }
  var unstack = function(str){
    var type = get_stack_type(str);
    if (type === "spaces") {
      return Array.from(str).map(function(c, i, a){
        var cp = c.codePointAt();
        var cp1 = a[i+1] ? a[i+1].codePointAt() : null;
        if (c === " " && idmap[cp1]) {
          return undefined;
        } else if (idmap[cp]) {
          return String.fromCodePoint.apply(null, idmap[cp]);
        } else {
          return c;
        }
      }).join("");
    } else if (type === "diff") {
      return unmake(str);
    } else {
      return str;
    }
  }
  this.make = make;
  this.unstack = unstack;
}

export default new stacker();
